class EfFilialSelector {
  static get $inject() {
    return ['$scope', 'gql', '$filter']
  }

  constructor($scope, gql, $filter) {
    this.apply = (fn) => $scope.$apply(fn)

    this.gql = gql
    this.$filter = $filter

    $scope.$watch(() => this.empresas, newValue => {
      if (newValue && !this.empresaSelecionada) {
        const filialIdOnCache = localStorage.getItem(`ef-filiais-selector-${this.empresaId}`)

        this.empresaSelecionada = newValue.find(filial => filial.id == filialIdOnCache)

        if (newValue.length == 1) {
          this.empresaSelecionada = newValue[0]
        }

        this.setViewValue()
      }
    })
  }

  $onInit() {
    this.ngModelCtrl.$setValidity('required', false)

    this.ngModelCtrl.$render = () => {
      this.empresaSelecionada = this.ngModelCtrl.$viewValue
    }
  }

  setViewValue() {
    this.ngModelCtrl.$setValidity('required', this.empresaSelecionada != null)

    if (this.empresaSelecionada && this.empresas.length > 1) {
      localStorage.setItem(`ef-filiais-selector-${this.empresaId}`, this.empresaSelecionada.id.toString())
    }

    if (this.ngModelCtrl.$valid) {
      this.ngModelCtrl.$setViewValue(this.empresaSelecionada)
    } else {
      this.ngModelCtrl.$setViewValue(null)
    }
  }

  highlight(search, empresa) {
    const cnpj = this.$filter('cpfCnpj')(empresa.cnpj)
    const text = `${cnpj} (${empresa.cidade}/${empresa.estado})`

    return search.split(' ').reduce(this.$filter('highlight'), text)
  }
}

angular.module('eficienciaFiscalModule').component('efFilialSelector', {
  controller: EfFilialSelector,
  bindings: {
    onChange: '&',
    empresas: '<',
    empresaId: '<',
    filter: '&?'
  },
  require: {
    ngModelCtrl: 'ngModel'
  },
  template: `
    <ui-select
      theme="bootstrap"
      name="empresa"
      ng-model="$ctrl.empresaSelecionada"
      ng-change="$ctrl.setViewValue()"
      ng-disabled="$ctrl.empresas.length == 1"
      style="width:100%"
      required="true"
    >
      <ui-select-match placeholder="Selecionar uma filial">
        {{$select.selected.cnpj | cpfCnpj}} ({{$select.selected.cidade}}/{{$select.selected.estado}})
      </ui-select-match>
      <ui-select-choices repeat="empresa in ($ctrl.empresas | filter: $select.search) track by empresa.id">
        <div ng-bind-html="$ctrl.highlight($select.search, empresa)"></div>
      </ui-select-choices>
    </ui-select>
  `
})
